// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { RefreshCw } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconRefreshCw(props: any) {
    return <IconBase icon={RefreshCw} {...props} />
  }

  export default IconRefreshCw
  